{
  "__title": "MovAI Boards — Wake your dashboards up",
  "__metaDescription": "Your dashboards are dead. Wake them up with MovAI Boards: an AI analyst inside your Google Data Studio report that answers in your clients' language with real numbers and filters the board on its own.",
  "__ogTitle": "MovAI Boards — Wake your dashboards up",
  "__ogDescription": "Boards that think with you: your clients ask and the dashboard answers with real numbers, filtering itself.",
  "__ldDescription": "An AI analyst inside your Google Data Studio report: your clients ask in their own language and the board answers with real numbers, filtering itself.",
  "enter": "Sign in",
  "kicker": "Your dashboards are dead",
  "title": "Wake them up with <span class=\"ld-mark\">Mov<i>AI</i></span> Boards",
  "sub": "Boards that think with you: your clients ask in their own language and the dashboard answers with real numbers — filtering itself to show them.",
  "cta": "Start free",
  "ctaPlans": "See plans",
  "mono": "For Google Data Studio dashboards",
  "stageNote": "Illustrative example — the assistant speaks about YOUR report’s data.",
  "stage.try": "Try it live — it’s a real board",
  "demo.u1": "Which region grew the most this month?",
  "demo.b1": "<b>North</b> grew <b>+18%</b> vs. last month, with $412K in sales. Filtering the board so you can see it.",
  "demo.chip": "Region · North",
  "demo.u2": "great, remove the filter",
  "demo.b2": "Done — the board shows <b>all regions</b> again. What else would you like to know?",
  "demo.kpi1": "Sales this month",
  "demo.kpi2": "Orders",
  "demo.kpi3": "Avg. ticket",
  "demo.chart1": "Sales by region",
  "demo.chart2": "12-week trend",
  "claim.title": "Your clients don’t want dashboards. <b>They want answers.</b>",
  "claim.body": "MovAI lives inside your own report: you don’t move your data, rebuild anything, or install anything on your sources. The AI reads what the board shows and answers with those numbers — it never makes them up.",
  "proof.1": "Answers with your real numbers",
  "proof.2": "The board obeys: filters and restores",
  "proof.3": "Share with a link, no sign-ups",
  "proof.4": "Bring your own AI key if you prefer",
  "how.title": "From report to analyst in <b>3 steps</b>.",
  "how.1t": "Connect your report",
  "how.1p": "Add the MovAI Boards extension to your Google Data Studio report and paste the URL in your account. The guide walks you through it.",
  "how.2t": "Ask in plain language",
  "how.2p": "“Which was the best month?”, “who concentrates the cost?” — the AI answers with the board’s numbers and applies the filters to show it.",
  "how.3t": "Share one link",
  "how.3p": "Every board has a public link you can enable, rotate or turn off anytime. Your clients ask without signing up.",
  "scene.q": "Your client opens the board at 11 pm, asks whatever comes to mind and gets the answer. <b>Without calling you.</b>",
  "scene.p": "And on Premium, Insights emails you a weekly AI summary of what your audience asked and the opportunities it leaves.",
  "plans.title": "Simple <b>pricing</b>",
  "plans.sub": "Annual: 2 months free and +20% weekly queries.",
  "cycle.m": "Monthly",
  "cycle.a": "Annual",
  "cycle.save": "2 months free +20%",
  "final.title": "Let your data <b>answer for itself</b>.",
  "final.cta": "Start free",
  "foot.terms": "Terms",
  "foot.privacy": "Privacy",
  "foot.support": "Support"
}
